import React from "react";
import { collectionGroup, orderBy, query, where } from "@firebase/firestore";
import { Timestamp } from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";

import { useTranslator } from "@/i18n/useTranslator";
import { DsText } from "@/src/components/ui/DsText";

import { NotesFeed } from "../NotesFeed";

type NoteType = {
  id: string;
  note: string;
  createdAt: Timestamp;
  createdBy: {
    id: string;
    photoURL: string;
    name: string;
  };
  files?: string[];
  jobId?: string;
  serviceId?: string;
  taskId?: string;
};

type TaskNotesPropsType = {
  jobId: string;
  serviceId: string;
  taskId: string;
  customer?: boolean;
};

export const TaskNotes = ({
  jobId,
  serviceId,
  taskId,
  customer = false,
}: TaskNotesPropsType) => {
  const { t } = useTranslator();
  const notesRoute = customer ? "customerNotes" : "notes";
  const firestore = useFirestore();
  const notesCollection = collectionGroup(firestore, notesRoute);
  const notesQuery = query(
    notesCollection,
    where("jobId", "==", jobId),
    where("serviceId", "==", serviceId),
    where("taskId", "in", ["", taskId]),
    orderBy("createdAt", "asc"),
  );

  const { status, data } = useFirestoreCollectionData(notesQuery, {
    idField: "id",
  });

  if (status === "loading") {
    return <DsText variant="body">{t("loading")}</DsText>;
  }

  return (
    <NotesFeed
      notes={data as NoteType[]}
      path={`jobs/${jobId}/services/${serviceId}/tasks/${taskId}/${notesRoute}`}
      ids={{ jobId, serviceId, taskId }}
      customer={customer}
    />
  );
};
